export const theme = {
  colors: {
    copy: '#EEEFF2',
    copyDimmed: '#73758E',
    brand: '#00FF80',
    outlineLight: '#292B43',
    outlineDark: '#1F2232',
    complimentaryTeal: '#00FFA3',
    complimentaryBlue: '#1E93FF',
    complimentaryCerise: '#F340CC',
    complimentaryPurple: '#882FFB',
    complimentaryYellow: '#FDE727',
    systemSuccess: '#2AF563',
    systemWarning: '#F9B22A',
    systemError: '#FB2F54',
    primaryBackgroundDark: '#11131F',
  },
  breakpoints: {
    large: '1200px',
    medium: '960px',
    small: '720px',
  },
  interactions: {
    standard: 'linear-gradient(180deg, #882FFB 0%, #5E1CB4 100%);',
    highlight:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), linear-gradient(180deg, #882FFB 0%, #5E1CB4 100%);',
    onPress:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(180deg, #5E1CB4 0%, #882FFB 100%);',
    disabled: 'linear-gradient(180deg, #3F4256 0%, #333544 100%)',
  },
  backgrounds: {
    primaryDark:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(0deg, rgba(21, 24, 38, 0.6), rgba(21, 24, 38, 0.6)), #11131F;',
    secondaryDark:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(180deg, rgba(39, 41, 63, 0.3) 0%, rgba(25, 27, 43, 0.3) 100%), #1F2133;',
    tertiaryDark:
      'linear-gradient(0deg, rgba(20, 22, 35, 0.4), rgba(20, 22, 35, 0.4)), #1C1E2F;',
  },
  gradients: {
    teal: 'linear-gradient(180deg, #00FFA3 0%, #0988FF 100%);',
    blue: 'linear-gradient(180deg, #0788FF 0%, #4D3AC8 47.92%, #5202B8 100%);',
    purple: 'linear-gradient(218.66deg, #882FFB 13.36%, #5F1DB5 86.05%);',
    dark: 'linear-gradient(218.66deg, #232539 13.36%, #191A2A 86.05%);',
    white: 'linear-gradient(226.33deg, #FFFFFF 19.04%, #C8C8D8 85.48%);',
  },
  sizes: {
    h1Size: '61px',
    h2Size: '48px',
    h3Size: '34px',
    h4Size: '24px',
    h5Size: '20px',
    h6Size: '16px',
    bodyLargeSize: '16px',
    bodyMediumSize: '14px',
    bodySmallSize: '12px',
    captionLargeSize: '12px',
    captionSmallSize: '10px',
    tinySize: '8px',
  },
};
